import { IOffersDataState } from '../../types/offersData';
import { EOffersActions, INewbuildingsAction } from '../../actions/offersData';
import { DEFAULT_OFFERS_DATA } from '../../constants/redux';

export function offersData(state: IOffersDataState = DEFAULT_OFFERS_DATA, action: INewbuildingsAction) {
  switch (action.type) {
    case EOffersActions.set:
      return action.data;
    case EOffersActions.setNewbuildingComparisonStatus: {
      // ЖК промо-сниппета живёт в отдельном контракте (newbuildingPromoSnippet) и не попадает
      // в state.newbuildings.byId, поэтому статус сравнения для него обновляем здесь.
      // При дубле ЖК (он же есть в выдаче) экшен обработают оба редьюсера — копии останутся синхронны.
      const promoSnippet = state.newbuildingPromoSnippet;

      if (!promoSnippet || promoSnippet.newbuilding.id !== action.newbuildingId) {
        return { ...state };
      }

      return {
        ...state,
        newbuildingPromoSnippet: {
          ...promoSnippet,
          newbuilding: {
            ...promoSnippet.newbuilding,
            comparisonStatus: action.comparisonStatus,
          },
        },
      };
    }
    default:
      return { ...state };
  }
}
